export type AcquirerFeeLevel = 1 | 2 | 3 | 4 | 5 | 6;

export type AcquirerFeeRates = {
  privateDebitPercentage: number;
  privateCreditPercentage: number;
  businessPercentage: number;
  model: "REV_SHARE" | "BUY_RATE";
};

export const ACQUIRER_FEE_LEVELS: Record<AcquirerFeeLevel, AcquirerFeeRates> = {
  1: {
    privateDebitPercentage: 0.49,
    privateCreditPercentage: 0.59,
    businessPercentage: 1.99,
    model: "REV_SHARE",
  },
  2: {
    privateDebitPercentage: 0.59,
    privateCreditPercentage: 0.69,
    businessPercentage: 1.99,
    model: "REV_SHARE",
  },
  3: {
    privateDebitPercentage: 0.69,
    privateCreditPercentage: 0.79,
    businessPercentage: 1.99,
    model: "BUY_RATE",
  },
  4: {
    privateDebitPercentage: 0.79,
    privateCreditPercentage: 0.89,
    businessPercentage: 1.99,
    model: "BUY_RATE",
  },
  5: {
    privateDebitPercentage: 0.89,
    privateCreditPercentage: 0.99,
    businessPercentage: 1.99,
    model: "BUY_RATE",
  },
  6: {
    privateDebitPercentage: 0.99,
    privateCreditPercentage: 1.09,
    businessPercentage: 1.99,
    model: "BUY_RATE",
  },
};

export const ACQUIRER_FEE_LEVEL_OPTIONS = Object.keys(ACQUIRER_FEE_LEVELS).map(
  (level) => Number(level) as AcquirerFeeLevel,
);

export const DEFAULT_ACQUIRER_FEE_LEVEL: AcquirerFeeLevel = 6;

export const findAcquirerFeeLevel = (
  privateDebitPercentage: number | undefined,
): AcquirerFeeLevel => {
  if (privateDebitPercentage === undefined) {
    return DEFAULT_ACQUIRER_FEE_LEVEL;
  }
  const match = ACQUIRER_FEE_LEVEL_OPTIONS.find(
    (level) =>
      ACQUIRER_FEE_LEVELS[level].privateDebitPercentage ===
      privateDebitPercentage,
  );
  return match ?? DEFAULT_ACQUIRER_FEE_LEVEL;
};
